import React from "react";
import { ReactComponent as MapPin } from "../../assets/Updated-imagery/locationPin.svg";
import { ReactComponent as BookOpen } from "../../assets/Updated-imagery/open-book_18709511.svg";
import { ReactComponent as RaiseHandIcon } from "../../assets/Updated-imagery/raiseHandCtaIcon.svg";
import Button from "../../components/ui/Button";
import bg from "../../assets/bg-star.png";
import { ReactComponent as UnderLine } from "../../assets/Updated-imagery/underlineArabic.svg";

const StoreLocatorRegisterCtaSection = () => {
    return (
        <div className="w-full flex-center-both flex-col space-y-4 max-w-7xl mb-20 mx-auto font-ibm items-center justify-center p-1 md:p-6">
            <div className="flex-center-both flex-col space-y-2 text-center relative ">
                <h1 className="font-ibm flex-center-both space-x-3 space-x-reverse font-semibold text-cocoaBrown-500 text-4xl md:text-5xl mb-8">
                    <div className="w-2 h-14 bg-tomato-500" />
                    <span>ابدأ معانا كمنفذ معتمد</span>
                    <div className="w-2 h-14 bg-tomato-500" />
                </h1>
                <div className="flex justify-center mt-1">
                    <UnderLine className="w-1/2" />
                </div>
            </div>
            <div className="relative w-full overflow-hidden rounded-3xl bg-[linear-gradient(270deg,_rgba(237,97,64,0.3)_-29.4%,_rgba(250,204,20,0.3)_97.56%)] border border-secYellow-300/50 shadow-2xl">
                <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-secYellow-300/30 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-tomato-300/30 to-transparent rounded-full blur-3xl"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-gradient-to-br from-secYellow-200/20 to-tomato-200/20 rounded-full blur-3xl"></div>

                <div
                    className="inset-0 hidden md:block w-full h-full z-0 absolute opacity-30 dark:invert-0 brightness-100 invert smooth"
                    style={{
                        backgroundImage: "url(" + bg + ")",
                        backgroundSize: "contain",
                        backgroundPosition: "center center",
                    }}
                ></div>

                <div className="relative z-10 h-full p-4 md:p-16">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-16 h-full">
                        <div className="flex-1 space-y-8">
                            <div className="inline-flex items-center gap-2 bg-white/80 dark:bg-black/50 backdrop-blur-sm text-secYellow-800 dark:text-secYellow-100 smooth px-6 py-3 rounded-full text-lg font-medium shadow-lg">
                                حابب تسجل منفذ جديد؟
                            </div>

                            <div className="space-y-6">
                                <p className="text-lg md:text-2xl font-semibold w-3/4 text-gray-700 dark:text-gray-200 smooth  leading-relaxed max-w-2xl">
                                    سجل منفذك التعليمي الآن واصبح جزءاً من منصة الأستاذ وليد محسن
                                    الرائدة في التعليم بمصر
                                </p>
                            </div>

                            {/* Features */}
                            <div className="space-y-6">
                                <div className="flex items-start gap-4">
                                    <div className="flex-shrink-0 w-14 h-14 bg-white/90 dark:bg-slate-700/50 smooth backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg">
                                        <MapPin className="w-6 h-6 text-secYellow-600" />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-900 dark:text-gray-50 smooth text-lg">
                                            موقع مميز
                                        </h4>
                                        <p className="text-gray-700 dark:text-gray-200 smooth">
                                            اجعل منفذك مرئياً للطلاب في منطقتك
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start gap-4">
                                    <div className="flex-shrink-0 w-14 h-14 bg-white/90 dark:bg-slate-700/50 smooth backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg">
                                        <BookOpen className="w-6 h-6 text-tomato-600" />
                                    </div>
                                    <div>
                                        <h4 className="font-semibold text-gray-900 dark:text-gray-50 smooth text-lg">
                                            محتوى تعليمي متقدم
                                        </h4>
                                        <p className="text-gray-700 dark:text-gray-200 smooth">
                                            يعني هتقد تبيع كتبنا وأكوادنا!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full md:w-96">
                            <div className=" backdrop-blur-sm rounded-2xl p-10 shadow-2xl border border-white/30 h-full flex flex-col justify-center">
                                <div className="text-center space-y-8">
                                    <div className="w-20 h-20 bg-gradient-to-br from-secYellow-300/20 to-tomato-300/20 rounded-full flex items-center justify-center mx-auto">
                                        <MapPin className="w-10 h-10 " />
                                    </div>

                                    <div className="space-y-3">
                                        <h3 className="text-xl md:text-3xl font-bold text-gray-900 dark:text-gray-100 smooth">
                                            سجل الآن
                                        </h3>
                                        <p className="text-gray-600 dark:text-gray-300 smooth text-base md:text-lg">
                                            املأ البيانات وسنتواصل معك خلال 24 ساعة
                                        </p>
                                    </div>

                                    <div className="space-y-4 flex-center-both">
                                        <Button
                                            className="w-full block font-semibold text-tomato-50 bg-tomato-400 py-2 relative z-10 border-none scale flex-center-both gap-2 max-w-[250px]"
                                            element="Link"
                                            to={"/store_locator_registeration"}
                                        >
                                            <RaiseHandIcon className="inline-block  w-6 h-6 ml-2" />
                                            تسجيل منفذ جديد
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="absolute top-16 right-16 w-3 h-3 bg-secYellow-500 rounded-full animate-pulse"></div>
                <div
                    className="absolute bottom-20 left-20 w-2 h-2 bg-tomato-500 rounded-full animate-pulse"
                    style={{ animationDelay: "1s" }}
                ></div>
                <div
                    className="absolute top-1/2 left-16 w-2.5 h-2.5 bg-secYellow-400 rounded-full animate-pulse"
                    style={{ animationDelay: "2s" }}
                ></div>
                <div
                    className="absolute top-1/4 right-1/4 w-2 h-2 bg-tomato-400 rounded-full animate-pulse"
                    style={{ animationDelay: "3s" }}
                ></div>
            </div>
        </div>
    );
};

export default StoreLocatorRegisterCtaSection;
